/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createReorderTermsResponseFromDiscriminatorValue, serializeReorderTermsRequest, serializeReorderTermsResponse, type ErrorResponse, type ReorderTermsRequest, type ReorderTermsResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/terms/reorder
 */
export interface ReorderRequestBuilder extends BaseRequestBuilder<ReorderRequestBuilder> {
    /**
     * Rearranges the organization's payment terms — the sequence is the display order everywhere terms are offered. Send every existing term exactly once, in the new order — adding, dropping, or repeating one is a 400. Values match case-insensitively and the casing on file is kept.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ReorderTermsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     put(body: ReorderTermsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ReorderTermsResponse | undefined>;
    /**
     * Rearranges the organization's payment terms — the sequence is the display order everywhere terms are offered. Send every existing term exactly once, in the new order — adding, dropping, or repeating one is a 400. Values match case-insensitively and the casing on file is kept.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: ReorderTermsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReorderRequestBuilderUriTemplate = "{+baseurl}/api/organizations/terms/reorder";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReorderRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ReorderRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createReorderTermsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReorderTermsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
